import React from 'react';

// LIBS
import classNames from 'classnames';
import get from 'lodash.get';

// COMPONENTS
import { Image, Container } from 'semantic-ui-react';
import Layouts from "../../components/layouts/index";
import Footer from '../../components/common/footer';
import PageBanner from '../../components/common/pageBanner';
import BoxedLogo from '../../components/common/boxedLogo';
import PageHeader from '../../components/common/pageHeader';
import PoweredBy from '../../components/common/poweredBy';
import GiftMatchingWidget from './giftMatchingWidget';

// HELPERS
import { isValueExists } from '../../helpers/valueHelper';

const DonatePage = props => {
    const wizardClasses = classNames(
        'wizard-body',
        props.className
    );

    const bannerTitle = get(props.customText, 'banner.title');
    const bannerDescription = get(props.customText, 'banner.description');

    return (
        <Layouts.Wizard>
            <PageBanner>
                <div className="image-wrapper">
                    <Image src={props.heroImageUrl} />
                </div>
                <div className="container">
                    <BoxedLogo logo={props.mainImageUrl} className="logo-overlapping image-cont border-padded" />
                    <div className="page-banner-title">
                        <PageHeader>
                            {bannerTitle || "Help us reach our goal"}
                        </PageHeader>
                        <p>{isValueExists(bannerDescription) ? bannerDescription : "Your donation will be made to Telethon7"}</p>
                    </div>
                </div>
            </PageBanner>
            <GiftMatchingWidget />
            <div className="donate-wizard">
                <Container className="steps-cont">
                    <div className={wizardClasses}>
                        {props.children}
                    </div>
                    <PoweredBy />
                </Container>
            </div>
            <Footer />
        </Layouts.Wizard>
    )
}

export default DonatePage;